import React from 'react';

export default function Step1(props){
    return <div className="seehi_step">
        <h2>Subsidieregeling energiebesparing eigen huis (SEEH)</h2>
        <p>Investeer in uw eigen woning met energiebesparende maatregelen. U krijgt een lagere energierekening, meer wooncomfort 
            en een beter verkoopbaar huis. Ook daalt de CO<sub>2</sub>-uitstoot en helpt u mee aan een beter milieu. U krijgt 
            subsidie als u voldoet aan de volgende voorwaarden:</p>
            
        <ul>
            <li>U neemt minstens 2 isolatiemaatregelen. Hoe meer maatregelen, hoe hoger de subsidie.</li>
            <li>U kunt daarbij vooraf een maatwerkadviesrapport laten opstellen (niet verplicht).</li>
            <li>De maatregelen zijn uitgevoerd na 15 augustus 2019. U vraagt de subsidie pas aan nadat het werk is afgerond en betaald.</li>
            <li>U bent eigenaar van de woning waarvoor de subsidie is aangevraagd en u woont er al of gaat er wonen na de renovatie.</li>
            <li>Voor de woning is niet eerder subsidie verstrekt vanuit de SEEH.</li>
        </ul>
    </div>;
}


// WEBPACK FOOTER //
// ./src/steps/step1.js